import type { PageBlockDefinition } from '../definition-types'

export const livewireCalloutDefinition: PageBlockDefinition = {
  type: 'livewire-callout',
  label: 'LiveWire Callout',
  description: 'Live or recorded intelligence briefing callout tile.',
  rowCompatible: true,
  columnCompatible: true,
  category: 'editorial',
  minArticles: 0,
  maxArticles: 1,
  slots: [],
  defaultConfig: {
    visualStyle: 'tile',
    showDuration: true,
    autoplayPreview: false,
  },
  editorFields: [
    {
      key: 'visualStyle',
      label: 'Visual Style',
      type: 'select',
      options: [
        { label: 'Tile', value: 'tile' },
        { label: 'Banner', value: 'banner' },
        { label: 'Compact', value: 'compact' },
      ],
    },
    { key: 'showDuration', label: 'Show Duration', type: 'toggle' },
    { key: 'autoplayPreview', label: 'Autoplay Preview', type: 'toggle' },
  ],
}
